import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    props: {
        eventName: {
            type: String,
            required: false,
            default: null,
        },

        component: {
            type: String,
            required: false,
            default: null,
        },
    },
    methods: {
        emitEvent() {
            if (this.component === 'modal-retailer-signup') {
                this.$showSignupModal()
            } else if (this.eventName && this.component) {
                EventBus.$emit(this.eventName, this.component)
            } else if (this.eventName) {
                EventBus.$emit(this.eventName)
            }
        },
    },
}
